import { MdDeleteForever, MdModeEdit } from "react-icons/md";
import { useEffect, useRef, useState } from "react";
import axiosInstance from "../../api/axiosInstance.js";
import { useLocation, useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import Loader from "../../common/Loader/index.js";
import Select from "react-select";
import Model from "../../common/Model/index.js";
import { notify, Toast } from "../../common/Toast/index.js";
import { FaStarOfLife } from "react-icons/fa";
import { IoPrintSharp, IoAdd } from "react-icons/io5";
import FormFields from "../../common/FormFields/index.js";
import { getUserMenuPermission } from "../../common/Helper/index.js";

const ManualDetails = () => {
  const today = new Date().toISOString()?.split("T")[0];
  const permission = getUserMenuPermission(9);
  const navigate = useNavigate();
  const location = useLocation();
  const { manualDetailsData } = location.state || {};
  const [errors, setErrors] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const [quotation, setQuotation] = useState({
    quotation_No: 0,
    quotation_Date: today,
    site_Id: "",
    stage_Id: 1,
    gross_Amount: 0,
    disc_Per: 0,
    disc_Amount: 0,
    gsT_Per: 18,
    gsT_Amount: 0,
    trasportation: 0,
    packing_Charge: 0,
    net_Amount: 0,
    remark: "",
    company_Id: "",
    stageId: null,
    finalAmount: "",
    finalProfileColor: "",
    glassColorType: "",
    workCompleteDate: "",
    reason: "",
    quote_Amount: "",
  });
  const [terms, setTerms] = useState([]);
  const [items, setItems] = useState([
    {
      item_Code: 0,
      item_Name: "",
      hsn_Sac: "",
      description: "",
      qty: 0,
      rate: 0,
      total_Amount: 0,
      image: null,
      isEditingDescription: false,
    },
  ]);
  const [newItem, setNewItem] = useState({
    item_Code: 0,
    item_Name: "",
    description: "",
    item_Rate: 0,
    item_Face: 0,
    item_Type: "",
    coil_Used: "",
    thickness: 0,
    image: null,
  });
  const [isSiteDetailsData, setIsSiteDetailsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [company, setCompany] = useState([]);
  const [allItems, setAllItems] = useState([]);
  const [isItemModalOpen, setIsItemModalOpen] = useState(false);
  const [isItemType, setIsItemType] = useState([]);
  const [isCoilData, setIsCoilData] = useState([]);
  const userId = localStorage.getItem("userId");
  const { selectedSite } = location.state || {};
  const descRefs = useRef({});

  useEffect(() => {
    fetchSiteData();

    if (selectedSite) {
      setQuotation((prev) => ({
        ...prev,
        site_Id: selectedSite.site_Id?.toString(),
      }));
    }
    if (!manualDetailsData) {
      fetchTermsData();
    }
  }, []);

  const fields = [
    {
      name: "item_Name",
      label: "Item Name",
      type: "text",
      required: true,
      errorMessage: "Item name is required",
    },
    { name: "description", label: "Description", type: "text" },
    {
      name: "item_Rate",
      label: "Item Rate",
      type: "number",
      required: true,
      min: 0,
      step: 0.01,
      errorMessage: "Positive value required",
    },
    { name: "item_Face", label: "Item Face", type: "number" },
    {
      name: "item_Type",
      label: "Item Type",
      type: "select",
      id: "item_Type",
      options: isItemType.map((type) => ({
        value: type.item_Type.toString(),
        label: type.item_Type_Name,
      })),
    },
    {
      name: "coil_Used",
      label: "Coil Used",
      type: "select",
      id: "coil_Used",
      options: isCoilData.map((coil) => ({
        value: coil.coil_Used.toString(),
        label: coil.coil_Name,
      })),
    },
    { name: "thickness", label: "Thickness", type: "number" },
    { name: "image", label: "Upload Image", type: "file" },
  ];

  const shouldShowCloseWonFields = (stageId) => {
    return [2, 6, 7].includes(stageId);
  };
  const isCloseWonEditable = (stageId) => {
    return stageId === 2;
  };

  const shouldShowCloseLostReason = (stageId) => {
    return stageId === 3;
  };
  const validateForm = () => {
    const newErrors = {};
    if (items.length === 0) {
      newErrors.items = "At least one item is required";
    } else {
      items.forEach((item, index) => {
        if (!item.item_Code) {
          newErrors[`item_${index}`] = `Item #${index + 1} requires a product`;
        }
        if (item.qty <= 0) {
          newErrors[`qty_${index}`] = `Item #${index + 1} quantity is required`;
        }
        if (item.rate <= 0) {
          newErrors[`rate_${index}`] = `Item #${index + 1} rate is required`;
        }
      });
    }
    if (!quotation.site_Id) {
      newErrors.site_Id = "Site Name is required";
    }
    if (!quotation.quotation_Date) {
      newErrors.quotation_Date = "Quotation Date is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const fetchItemType = async () => {
    if (isItemType.length > 0) return;
    try {
      const res = await axiosInstance.get(`Item/GetAllItemType`);
      setIsItemType(res.data);
    } catch (error) {
      console.error("Error fetching GetAllItemType:", error);
    }
  };
  const fetchCoilData = async () => {
    if (isCoilData.length > 0) return;
    try {
      const res = await axiosInstance.get(`Item/GetCoilMaster`);
      setIsCoilData(res.data);
    } catch (error) {
      console.error("Error fetching GetCoilMaster:", error);
    }
  };
  const fetchCompanyData = async () => {
    if (company.length > 0) return;
    try {
      const res = await axiosInstance.get(`ManualQuotation/GetAllCompanies`);
      setCompany(res.data);
    } catch (error) {
      console.error("Error fetching GetCoilMaster:", error);
    }
  };
  useEffect(() => {
    fetchSiteData();
    fetchItemType();
    fetchCoilData();
    fetchItems();
    fetchCompanyData();
    if (manualDetailsData) {
      setQuotation((prev) => ({
        ...prev,
        ...manualDetailsData.manualQuotation,
      }));
      // setItems(manualDetailsData.items || []);
      setItems(
        manualDetailsData.items?.map((item) => ({
          ...item,
          isEditingDescription: false,
        })) || []
      );

      setTerms(manualDetailsData.terms || []);

      setIsEditing(true);
    } else {
      fetchTermsData();
    }
  }, [manualDetailsData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setQuotation((prev) => ({
      ...prev,
      [name]: name === "quotation_No" ? parseInt(value, 10) || 0 : value,
    }));
  };
  const handleInputItemChange = (e) => {
    const { name, value } = e.target;
    setNewItem((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const fetchItems = async () => {
    try {
      const response = await axiosInstance.get("Item/GetAll");
      setAllItems(response.data);
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };
  const totalAmountBeforeTax = items.reduce(
    (sum, item) => sum + item.total_Amount,
    0
  );
  const discountAmount = (totalAmountBeforeTax * (parseFloat(quotation.disc_Per) || 0)) / 100;
  const total = totalAmountBeforeTax - discountAmount;
  const gstAmount = (total * quotation.gsT_Per) / 100;
  const grandTotal =
    total + gstAmount + quotation.trasportation + quotation.packing_Charge;

  const addNewItem = () => {
    setItems([
      ...items,
      {
        item_Code: "",
        item_Name: "",
        hsn_Sac: "",
        description: "",
        qty: 0,
        rate: 0,
        total_Amount: 0,
      },
    ]);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataToSend = new FormData();
    formDataToSend.append("Item_Code", newItem.item_Code || 0);
    formDataToSend.append("Item_Name", newItem.item_Name);
    formDataToSend.append("Description", newItem.description);
    formDataToSend.append("Item_Rate", newItem.item_Rate);
    formDataToSend.append("Item_Type", parseInt(newItem.item_Type) || 0);
    formDataToSend.append("Item_Face", Number(newItem.item_Face));
    formDataToSend.append("Coil_Used", parseInt(newItem.coil_Used) || 0);
    formDataToSend.append("Thickness", Number(newItem.thickness));

    if (newItem.image) {
      formDataToSend.append("image", newItem.image);
    }

    try {
      await axiosInstance.post("Item/SaveUpdate", formDataToSend, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      fetchItems();
      setIsItemModalOpen(false);
      notify(
        isEditing ? "Item updated successfully!" : "Item added successfully!",
        "success"
      );
      setNewItem({
        item_Code: "",
        item_Name: "",
        description: "",
        item_Rate: "",
        item_Type: "",
        item_Face: "",
        coil_Used: "",
        thickness: "",
        image: null,
      });

      document.getElementById("fileInput").value = "";
    } catch (err) {
      console.error("Error submitting form:", err);
    }
  };
  const handleItemChange = (index, selectedOptionOrEvent) => {
    setItems((prevItems) => {
      const updatedItems = [...prevItems];
      if (selectedOptionOrEvent?.target) {
        const { name, value } = selectedOptionOrEvent.target;

        let finalValue = value;
        if (name === "rate") {
          finalValue = parseInt(value, 10) || 0;
        }

        updatedItems[index] = {
          ...updatedItems[index],
          [name]: finalValue,
        };
        updatedItems[index].total_Amount =
          (parseFloat(updatedItems[index].qty) || 0) *
          (parseFloat(updatedItems[index].rate) || 0);
      } else {
        if (!selectedOptionOrEvent) {
          updatedItems[index] = {
            item_Code: "",
            item_Name: "",
            hsn_Sac: "",
            description: "",
            rate: 0,
            total_Amount: 0,
            qty: 0,
          };
        } else if (selectedOptionOrEvent.value === "add-newItem") {
          setIsItemModalOpen(true);
          return prevItems;
        } else {
          const selectedItem = allItems.find(
            (item) =>
              String(item.item_Code) === String(selectedOptionOrEvent.value)
          );

          if (selectedItem) {
            updatedItems[index] = {
              ...updatedItems[index],
              item_Code: selectedItem.item_Code || "",
              item_Name: selectedItem.item_Name || "",
              hsn_Sac: selectedItem.hsn_Sac || "",
              description: selectedItem.description || "",
              rate: selectedItem.item_Rate || 0,
            };
          }
        }
      }

      return updatedItems;
    });
  };

  useEffect(() => {
    items.forEach((item, index) => {
      if (item.isEditingDescription && descRefs.current[index]) {
        const el = descRefs.current[index];
        el.style.height = "auto";
        el.style.height = el.scrollHeight + "px";
      }
    });
  }, [items]);

  const handleItemDelete = async (index) => {
    const updatedItems = [...items];
    updatedItems.splice(index, 1);
    setItems(updatedItems);
  };

  const fetchSiteData = async () => {
    try {
      const { data } = await axiosInstance.get("SiteDetail/GetAll");
      setIsSiteDetailsData(data);
    } catch (error) {
      console.error("Error fetching site details:", error);
    }
  };

  const handleSiteChange = (selectedOption) => {
    const siteId = selectedOption ? selectedOption.value : "";
    setQuotation((prev) => ({
      ...prev,
      site_Id: siteId,
    }));
    if (siteId === "add-new") {
      navigate("/transaction/site-details");
    }
  };
  useEffect(() => {
    if (manualDetailsData && isSiteDetailsData.length > 0) {
      setQuotation((prev) => ({
        ...prev,
        ...manualDetailsData.manualQuotation,
        site_Id: String(manualDetailsData.manualQuotation.site_Id),
        stageId: manualDetailsData.manualQuotation.stage_Id,
        finalAmount: manualDetailsData.manualQuotation.final_Amount || "",
        finalProfileColor:
          manualDetailsData.manualQuotation.final_Profile_Color || "",
        glassColorType:
          manualDetailsData.manualQuotation.glass_Color_Type || "",
        workCompleteDate:
          manualDetailsData.manualQuotation.work_Complete_Date?.split("T")[0] ||
          "",
        reason: manualDetailsData.manualQuotation.reason || "",
      }));
    }
  }, [manualDetailsData, isSiteDetailsData]);

  const fetchTermsData = async () => {
    try {
      setLoading(true);
      let response;
      if (quotation.quotation_No === 0 && terms.length === 0) {
        response = await axiosInstance.get("Terms/GetAll");
        const formattedTerms = response.data?.map((term, index) => ({
          seq_No: index + 1,
          term_Name: term.term_Name,
          term_Id: term.term_Id,
          isEditing: false,
        }));
        setTerms(formattedTerms);
      }
    } catch (error) {
      console.error("Error fetching terms:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleAddTerm = () => {
    setTerms((prevTerms) => {
      if (quotation.quotation_No === 0) {
        const newTermId =
          prevTerms.length > 0
            ? prevTerms[prevTerms.length - 1].term_Id + 1
            : 1;
        return [
          ...prevTerms,
          { term_Id: newTermId, term_Name: "", isEditing: true },
        ];
      } else {
        const newSeqNo =
          prevTerms.length > 0 ? prevTerms[prevTerms.length - 1].seq_No + 1 : 1;
        return [
          ...prevTerms,
          { seq_No: newSeqNo, term_Name: "", isEditing: true },
        ];
      }
    });
  };

  const handleEditTerms = (id) => {
    setTerms((prevTerms) =>
      prevTerms?.map((term) =>
        (quotation.quotation_No === 0 ? term.term_Id : term.seq_No) === id
          ? { ...term, isEditing: true }
          : term
      )
    );
  };

  const handleDeleteTerm = async (seq_No) => {
    if (quotation.quotation_No === 0) {
      setTerms((prevTerms) =>
        prevTerms.filter((term) => term.term_Id !== seq_No)
      );
    } else {
      try {
        await axiosInstance.delete(
          `ManualQuotation/DeleteManualTerm/${seq_No}`
        );
        setTerms((prevTerms) =>
          prevTerms.filter((term) => term.seq_No !== seq_No)
        );
      } catch (error) {
        console.error("Error deleting term:", error);
      }
    }
  };

  const handleTermChange = (index, event) => {
    const { name, value } = event.target;
    setTerms((prevTerms) =>
      prevTerms?.map((term, i) =>
        i === index ? { ...term, [name]: value } : term
      )
    );
  };

  const toggleDescriptionEdit = (index, isEditing) => {
    setItems((prevItems) =>
      prevItems.map((item, i) =>
        i === index ? { ...item, isEditingDescription: isEditing } : item
      )
    );
  };

  const handleSave = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    const isUpdate = quotation.quotation_No > 0;
    const payload = {
      manualQuotation: {
        Manual_Quotation_Id: quotation.manual_Quotation_Id || 0,
        Quotation_No: isUpdate ? quotation.quotation_No : undefined,
        Quotation_Date: quotation.quotation_Date,
        Site_Id: quotation.site_Id,
        Stage_Id: quotation.stage_Id,
        Gross_Amount: totalAmountBeforeTax,
        Disc_Per: parseFloat(quotation.disc_Per) || 0,
        Disc_Amount: discountAmount,
        GST_Per: quotation.gsT_Per,
        GST_Amount: gstAmount,
        Trasportation: quotation.trasportation,
        Packing_Charge: quotation.packing_Charge,
        Net_Amount: grandTotal,
        Remark: quotation.remark,
        company_Id: quotation.company_Id,
        CreatedBy: userId,
        ...(Number(quotation.stageId) === 2 && {
          Final_Amount: quotation.finalAmount,
          Final_Profile_Color: quotation.finalProfileColor,
          Glass_Color_Type: quotation.glassColorType,
          Work_Complete_Date: quotation.workCompleteDate
            ? new Date(quotation.workCompleteDate).toISOString()
            : null,
        }),
        ...(Number(quotation.stageId) === 3 && {
          Reason: quotation.reason,
        }),
      },
      items: items?.map((item) => ({
        Item_Code: item.item_Code,
        description: item.description,
        Qty: item.qty,
        Rate: item.rate,
        Total_Amount: item.total_Amount,
      })),
      terms: terms?.map((term) => ({
        Seq_No: isUpdate ? term.seq_No || 0 : 0,
        Quotation_No: isUpdate ? quotation.quotation_No : undefined,
        Term_Name: term.term_Name,
        Created_By: 1,
        Modified_By: isUpdate ? 1 : null,
      })),
    };

    try {
      setLoading(true);
      const response = await axiosInstance.post(
        "ManualQuotation/SaveOrUpdate",
        payload
      );

      if (response.data) {
        notify(
          isEditing
            ? "Manually Quotation updated successfully!"
            : "Manually Quotation added successfully!",
          "success"
        );
        setTimeout(() => navigate("/quotes/manual-quotation"), 1000);
      } else {
        notify("Something went wrong. Please try again.");
      }
    } catch (error) {
      notify("Error saving quotation:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePrint = async () => {
    try {
      setLoading(true);

      const response = await axiosInstance.get(
        `ManualQuotation/ManualQuotePrint/${quotation.quotation_No}`,
        { responseType: "blob" }
      );

      if (response.status === 200) {
        const site = isSiteDetailsData.find(
          (s) => String(s.site_Id) === String(quotation.site_Id)
        );
        const siteName = site?.site_Name?.replace(/\s+/g, "_") || "UnknownSite";
        const fileName = `Q_${quotation.quotation_No}_${siteName}.pdf`;

        const blob = new Blob([response.data], { type: "application/pdf" });
        saveAs(blob, fileName);

        const url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");
      } else {
        alert("Failed to generate PDF. Please try again later.");
      }
    } catch (error) {
      console.error("Error printing quotation:", error);

      const errorMessage =
        error.response?.data?.message || "Unknown error occurred.";

      if (errorMessage.includes("Select.HtmlToPdf")) {
        alert(
          "PDF generation is currently unavailable. Please contact support."
        );
      } else {
        alert(`An error occurred while printing: ${errorMessage}`);
      }
    } finally {
      setLoading(false);
    }
  };

  const options = [
    ...isSiteDetailsData?.map((site) => ({
      value: site.site_Id?.toString() || "",
      label: site.site_Name || "Unnamed Site",
    })),
    { value: "add-new", label: "+ Add New Site Details" },
  ];
  const itemOptions = [
    ...allItems?.map((item) => ({
      value: item.item_Code?.toString() || "",
      label: item.item_Name || "Unnamed Item",
    })),
    { value: "add-newItem", label: "+ Add New Item" },
  ];
  const companyOptions = [
    ...company.map((com) => ({
      value: com.company_Id?.toString() || "",
      label: com.company_Name || "Unnamed Company",
    })),
  ];

  const premiumSelectStyles = (error = false) => ({
    control: (base, state) => ({
      ...base,
      borderRadius: "0.5rem",
      padding: "0px 4px",
      border: error ? "1.5px solid #fda4af" : state.isFocused ? "1.5px solid #405189" : "1.5px solid #e2e8f0",
      backgroundColor: error ? "#fff1f2" : "white",
      boxShadow: state.isFocused ? "0 0 0 4px rgba(64, 81, 137, 0.05)" : "none",
      transition: "all 0.2s ease",
      minHeight: "32px",
      height: "32px",
      "&:hover": { borderColor: state.isFocused ? "#405189" : "#cbd5e1" },
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0 6px",
    }),
    menu: (base) => ({
      ...base,
      borderRadius: "1rem",
      overflow: "hidden",
      boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1)",
      border: "1px solid #f1f5f9",
      padding: "4px",
      zIndex: 9999999,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999999 }),
    option: (base, state) => ({
      ...base,
      borderRadius: "0.5rem",
      backgroundColor: state.isSelected ? "#405189" : state.isFocused ? "#f8fafc" : "transparent",
      color: state.isSelected ? "white" : "#475569",
      padding: "6px 10px",
      fontWeight: state.isSelected ? "700" : "500",
      fontSize: "0.75rem",
      cursor: "pointer",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#94a3b8",
      fontSize: "0.75rem",
      fontWeight: "600",
    }),
    singleValue: (base) => ({
      ...base,
      color: "#1e293b",
      fontWeight: "700",
      fontSize: "0.75rem",
    }),
    indicatorSeparator: () => ({ display: "none" }),
    dropdownIndicator: (base, state) => ({
      ...base,
      color: state.isFocused ? "#405189" : "#cbd5e1",
      padding: "2px",
    }),
  });
  return (
    <>
      <Toast />
      <div>
        {loading ? (
          <div className="flex items-center justify-center min-h-[60vh]">
            <Loader />
          </div>
        ) : (
          <div>
            {/* Header section */}
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-6 gap-4">
              <div className="flex flex-col">
                <h1 className="text-xl font-black text-slate-800 tracking-tight uppercase">Manual Details</h1>
                <p className="text-[11px] text-slate-400 font-bold uppercase tracking-wider mt-0.5">Design and customize manual quotation parameters</p>
              </div>
              <button
                className="px-4 py-2 bg-white hover:bg-slate-50 text-slate-700 text-[11px] font-black uppercase tracking-widest rounded-xl border border-slate-200 shadow-sm transition-all flex items-center gap-2 active:scale-95"
                onClick={() => navigate(`/quotes/manual-quotation`)}
              >
                <span className="text-lg">←</span> Back to List
              </button>
            </div>

            <form className="space-y-4" onSubmit={handleSave}>
              {/* Primary Attributes Card */}
              <div className="bg-white p-5 rounded-2xl shadow-sm border border-slate-100 relative overflow-hidden">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-primary/40 to-primary"></div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
                  {/* Left Column: Quotation No & Site Details */}
                  <div className="space-y-6">
                    <div className="flex flex-col space-y-2">
                      <label className="text-xs font-bold text-gray-800">
                        Quotation No
                      </label>
                      <input
                        id="quotationNo"
                        name="quotation_No"
                        type="text"
                        value={quotation.quotation_No}
                        onChange={handleInputChange}
                        disabled
                        className="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-slate-400 font-bold cursor-not-allowed text-xs focus:ring-1 focus:ring-primary/20 outline-none transition-all"
                      />
                    </div>

                    <div className="flex flex-col space-y-2">
                      <div className="flex items-center gap-2">
                        <label className="text-xs font-bold text-gray-800 flex items-center gap-1.5">
                          Site Name
                          <FaStarOfLife className="text-red-500 w-1.5 h-1.5" />
                        </label>
                      </div>
                      <Select
                        options={options}
                        value={options.find((option) => String(option.value) === String(quotation.site_Id)) || null}
                        isClearable
                        isSearchable
                        onChange={handleSiteChange}
                        menuPortalTarget={document.body}
                        styles={premiumSelectStyles(errors.site_Id)}
                        placeholder="Select..."
                      />
                      {errors.site_Id && (
                        <p className="text-red-500 text-[10px] font-black mt-1 uppercase italic tracking-tighter">{errors.site_Id}</p>
                      )}

                      {/* Site Details List */}

                    </div>
                  </div>

                  {/* Right Column: Date, Company */}
                  <div className="space-y-6">
                    <div className="flex flex-col space-y-2">
                      <label className="text-xs font-bold text-gray-800 flex items-center gap-1.5">
                        Quotation Date
                        <FaStarOfLife className="text-red-500 w-1.5 h-1.5" />
                      </label>
                      <input
                        id="quotation_Date"
                        name="quotation_Date"
                        type="date"
                        value={quotation.quotation_Date.split("T")[0]}
                        onChange={handleInputChange}
                        onFocus={(e) => e.target.showPicker()}
                        className={`w-full rounded-lg border px-3 py-2 outline-none transition-all duration-300 font-bold text-xs ${errors.quotation_Date
                          ? "border-red-300 bg-red-50/20"
                          : "border-slate-200 bg-white hover:border-primary/30 focus:border-primary ring-primary/5 focus:ring-4"
                          }`}
                      />
                      {errors.quotation_Date && (
                        <p className="text-red-500 text-[10px] font-black mt-1 uppercase italic tracking-tighter">{errors.quotation_Date}</p>
                      )}
                    </div>

                    <div className="flex flex-col space-y-2">
                      <label className="text-xs font-bold text-gray-800">
                        Company
                      </label>
                      <Select
                        options={companyOptions}
                        value={quotation.company_Id ? companyOptions.find((option) => Number(option.value) === Number(quotation.company_Id)) || null : null}
                        isClearable
                        isSearchable
                        menuPortalTarget={document.body}
                        onChange={(option) => setQuotation((prev) => ({ ...prev, company_Id: option ? option.value : "" }))}
                        styles={premiumSelectStyles()}
                        placeholder="Select Company"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Items Table Section */}
              <div className="bg-white rounded-[2rem] shadow-sm border border-slate-100 overflow-hidden">
                <div className="bg-slate-50/50 px-8 py-4 border-b border-slate-100 flex justify-between items-center">
                  <h2 className="text-[10px] font-black text-slate-500 uppercase tracking-[0.2em]">LINE ITEMS</h2>
                  <div className="px-3 py-1 bg-white border border-slate-200 rounded-full text-[9px] font-black text-slate-400 uppercase tracking-widest">
                    {items?.length || 0} PRODUCTS
                  </div>
                </div>

                <div className="p-0 overflow-x-auto">
                  <table className="w-full border-collapse">
                    <thead>
                      <tr className="bg-white border-b border-slate-100">
                        <th className="px-8 py-4 text-left text-[10px] font-black text-slate-400 uppercase tracking-widest">ITEM & DESCRIPTION</th>
                        <th className="px-3 py-4 text-center text-[10px] font-black text-slate-400 uppercase tracking-widest w-32">HSN</th>
                        <th className="px-3 py-4 text-center text-[10px] font-black text-slate-400 uppercase tracking-widest w-24">QTY</th>
                        <th className="px-3 py-4 text-left text-[10px] font-black text-slate-400 uppercase tracking-widest w-32">RATE</th>
                        <th className="px-3 py-4 text-right text-[10px] font-black text-slate-400 uppercase tracking-widest w-32">AMOUNT</th>
                        <th className="px-6 py-4 text-center text-[10px] font-black text-slate-400 uppercase tracking-widest w-28"></th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-50">
                      {items?.map((item, index) => (
                        <tr key={index} className="group hover:bg-slate-50/20 transition-colors">
                          <td className="px-8 py-5 min-w-[350px]">
                            <div className="flex flex-col gap-2">
                              <Select
                                options={itemOptions}
                                value={itemOptions.find((option) => String(option.value) === String(items[index]?.item_Code)) || null}
                                onChange={(opt) => handleItemChange(index, opt)}
                                menuPortalTarget={document.body}
                                styles={premiumSelectStyles()}
                              />
                              <div className="relative group">
                                {item.isEditingDescription ? (
                                  <textarea
                                    ref={(el) => { if (el) descRefs.current[index] = el; }}
                                    value={item.description}
                                    onChange={(e) => {
                                      const el = e.target;
                                      el.style.height = "auto";
                                      el.style.height = el.scrollHeight + "px";
                                      handleItemChange(index, { target: { name: "description", value: el.value } });
                                    }}
                                    onBlur={() => toggleDescriptionEdit(index, false)}
                                    rows={1}
                                    autoFocus
                                    className="w-full bg-white border border-primary/20 rounded-lg px-3 py-2 text-xs font-semibold focus:ring-4 focus:ring-primary/5 outline-none transition-all resize-none shadow-sm"
                                  />
                                ) : (
                                  <div className="flex items-start gap-2 py-1 rounded transition-all cursor-text group-hover:bg-white"
                                    onClick={() => toggleDescriptionEdit(index, true)}>
                                    <p className="text-slate-500 text-[11px] leading-relaxed font-medium line-clamp-2 italic">
                                      {item.description || "Click to add description..."}
                                    </p>
                                    <MdModeEdit className="w-3 h-3 text-slate-300 group-hover:text-primary transition-colors flex-shrink-0 mt-0.5" />
                                  </div>
                                )}
                              </div>
                            </div>
                          </td>
                          <td className="px-3 py-5">
                            <div className="flex justify-center">
                              <span className="text-slate-400 font-bold text-[10px] bg-slate-50 h-8 w-24 flex items-center justify-center rounded-lg border border-slate-100 uppercase tracking-tighter">
                                {item.hsn_Sac || "—"}
                              </span>
                            </div>
                          </td>
                          <td className="px-3 py-5 text-center">
                            <input
                              type="text"
                              value={items[index]?.qty || ""}
                              onChange={(e) => handleItemChange(index, e)}
                              name="qty"
                              placeholder="0"
                              className="w-24 bg-white border border-slate-200 rounded-lg h-8 text-center font-bold text-slate-700 outline-none focus:border-primary/50 transition-all text-xs shadow-sm"
                            />
                          </td>
                          <td className="px-3 py-5">
                            <div className="relative flex items-center">
                              <span className="absolute left-2.5 text-slate-400 text-[10px] font-bold">₹</span>
                              <input
                                type="text"
                                name="rate"
                                value={items[index]?.rate || ""}
                                onChange={(e) => handleItemChange(index, e)}
                                placeholder="0.00"
                                className="w-32 bg-white border border-slate-200 rounded-lg h-8 pl-6 pr-2 font-bold text-slate-700 outline-none focus:border-primary/50 transition-all text-xs shadow-sm"
                              />
                            </div>
                          </td>
                          <td className="px-3 py-5 text-right">
                            <span className="text-[12px] font-black text-slate-800 tracking-tight">₹{item.total_Amount.toLocaleString(undefined, { minimumFractionDigits: 2 })}</span>
                          </td>
                          <td className="px-3 py-5 text-center">
                            <div className="flex items-center justify-center gap-2">
                              <button
                                type="button"
                                onClick={addNewItem}
                                className="p-1.5 bg-primary/50 text-white rounded-lg hover:bg-primary transition-all active:scale-95 border border-primary/20 shadow-sm flex items-center justify-center"
                                title="Add Row Above"
                              >
                                <IoAdd size={16} />
                              </button>
                              <button
                                type="button"
                                onClick={() => handleItemDelete(index)}
                                className="p-1.5 bg-red-50 text-red-400 rounded-lg hover:bg-red-500 hover:text-white transition-all active:scale-95 border border-red-100/50 shadow-sm flex items-center justify-center"
                                title="Delete Item"
                              >
                                <MdDeleteForever size={16} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
                {/* Terms List Card */}
                <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden flex flex-col">
                  <div className="bg-[#f4f7fd] px-6 py-4 border-b border-slate-200 flex justify-between items-center">
                    <h2 className="text-sm font-bold text-[#405189]">GENERAL TERMS</h2>
                    <button
                      type="button"
                      className="text-[9px] font-black text-primary bg-primary/10 px-3 py-1 rounded-full hover:bg-primary hover:text-white transition-all uppercase tracking-widest"
                      onClick={handleAddTerm}
                    >
                      + ADD NEW
                    </button>
                    {errors.terms && <p className="text-red-500 text-[10px] font-bold ml-2">{errors.terms}</p>}
                  </div>
                  <div className="p-4 space-y-2 max-h-[300px] overflow-y-auto">
                    {terms?.length === 0 && (
                      <div className="flex flex-col items-center justify-center py-6 text-slate-300">
                        <p className="text-[10px] font-black uppercase tracking-widest">No terms defined</p>
                      </div>
                    )}
                    {terms?.map((term, index) => (
                      <div key={index} className="flex items-center gap-3 bg-slate-50/50 rounded-xl p-1 border border-slate-100 group transition-all hover:bg-white hover:shadow-sm">
                        <textarea
                          name="term_Name"
                          value={term.term_Name || ""}
                          onChange={(e) => handleTermChange(index, e)}
                          disabled={!term.isEditing}
                          rows={1}
                          className={`flex-grow bg-transparent text-[12px] font-bold leading-normal outline-none transition-all resize-none ${term.isEditing ? "text-primary border-b border-primary/20" : "text-slate-600"}`}
                          placeholder="Type term..."
                        />
                        <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                          <button
                            type="button"
                            className={`p-1.5 rounded-lg transition-all ${term.isEditing ? "bg-primary text-white" : "bg-white text-slate-400 hover:text-primary border border-slate-100"}`}
                            onClick={() => handleEditTerms(quotation.quotation_No === 0 ? term.term_Id : term.seq_No)}
                          >
                            <MdModeEdit size={14} />
                          </button>
                          <button
                            type="button"
                            className="p-1.5 bg-white text-slate-400 hover:text-red-500 rounded-lg border border-slate-100 transition-all"
                            onClick={() => handleDeleteTerm(quotation.quotation_No === 0 ? term.term_Id : term.seq_No)}
                          >
                            <MdDeleteForever size={14} />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Financial Summary Card */}
                <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden flex flex-col h-full">
                  <div className="bg-[#f4f7fd] px-6 py-4 border-b border-slate-200">
                    <h2 className="text-sm font-bold text-[#405189]">Account List</h2>
                  </div>
                  <div className="p-6 space-y-4">
                    <div className="flex justify-between items-center text-[#495057]">
                      <span className="text-sm font-medium">Total Amount Before Tax:</span>
                      <span className="text-sm font-bold">₹{totalAmountBeforeTax.toLocaleString(undefined, { minimumFractionDigits: 2 })}</span>
                    </div>

                    <div className="flex justify-between items-center text-[#495057]">
                      <span className="text-sm font-medium">Discount (%):</span>
                      <div className="flex items-center gap-2">
                        <input
                          type="text"
                          value={quotation.disc_Per}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (val === "" || /^\d*\.?\d*$/.test(val)) setQuotation(prev => ({ ...prev, disc_Per: val }));
                          }}
                          className="w-24 bg-white border border-slate-200 rounded-lg px-3 py-1.5 text-right font-medium text-[#495057] focus:border-[#405189] outline-none text-sm"
                          placeholder="0"
                        />
                        <span className="text-[#495057] font-medium">= ₹{discountAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })}</span>
                      </div>
                    </div>

                    <div className="flex justify-between items-center text-[#495057]">
                      <span className="text-sm font-medium">Transportation:</span>
                      <input
                        type="text"
                        value={quotation.trasportation}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val === "" || /^\d*\.?\d*$/.test(val)) setQuotation(prev => ({ ...prev, trasportation: Number(val) }));
                        }}
                        className="w-24 bg-white border border-slate-200 rounded-lg px-3 py-1.5 text-right font-medium text-[#495057] focus:border-[#405189] outline-none text-sm"
                        placeholder="0"
                      />
                    </div>

                    <div className="flex justify-between items-center text-[#495057]">
                      <span className="text-sm font-medium">Packing Charge:</span>
                      <input
                        type="text"
                        value={quotation.packing_Charge}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val === "" || /^\d*\.?\d*$/.test(val)) setQuotation(prev => ({ ...prev, packing_Charge: Number(val) }));
                        }}
                        className="w-24 bg-white border border-slate-200 rounded-lg px-3 py-1.5 text-right font-medium text-[#495057] focus:border-[#405189] outline-none text-sm"
                        placeholder="0"
                      />
                    </div>

                    <div className="flex justify-between items-center text-[#495057]">
                      <span className="text-sm font-medium">Total:</span>
                      <span className="text-sm font-bold">₹{total.toLocaleString(undefined, { minimumFractionDigits: 2 })}</span>
                    </div>

                    <div className="flex justify-between items-center text-[#495057]">
                      <span className="text-sm font-medium">GST (%):</span>
                      <div className="flex items-center gap-2">
                        <input
                          type="text"
                          value={quotation.gsT_Per}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (val === "" || /^\d*\.?\d*$/.test(val)) setQuotation(prev => ({ ...prev, gsT_Per: Number(val) }));
                          }}
                          className="w-24 bg-white border border-slate-200 rounded-lg px-3 py-1.5 text-right font-medium text-[#495057] focus:border-[#405189] outline-none text-sm"
                          placeholder="18"
                        />
                        <span className="text-[#495057] font-medium">= ₹{gstAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })}</span>
                      </div>
                    </div>

                    <div className="h-px bg-slate-100 my-4" />

                    <div className="flex justify-between items-center pt-2">
                      <span className="text-lg font-bold text-[#405189]">Grand Total:</span>
                      <span className="text-xl font-bold text-[#405189]">₹{grandTotal?.toLocaleString(undefined, { minimumFractionDigits: 2 })}</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Remarks and Stages */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <div className="bg-white rounded-3xl shadow-xl shadow-slate-200/30 border border-slate-100 overflow-hidden flex flex-col">
                  <div className="bg-slate-50/50 px-6 py-3 border-b border-slate-100">
                    <h2 className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Additional Notes</h2>
                  </div>
                  <div className="p-6 flex-grow">
                    <textarea
                      id="remark"
                      rows="4"
                      name="remark"
                      value={quotation.remark}
                      onChange={handleInputChange}
                      className="w-full rounded-2xl border border-slate-100 bg-slate-50/30 px-4 py-3 outline-none focus:border-primary transition-all placeholder:text-slate-300 font-black text-xs"
                      placeholder="Enter any internal remarks or specific notes..."
                    />
                  </div>
                </div>

                <div className={` ${Number(quotation.quotation_No) === 0 || Number(quotation.stageId) === 1 ? "hidden" : "bg-white rounded-3xl shadow-xl shadow-slate-200/30 border border-slate-100 overflow-hidden flex flex-col"}`}>
                  <div className="bg-slate-50/50 px-6 py-3 border-b border-slate-100">
                    <h2 className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Stage Finalization</h2>
                  </div>
                  <div className="p-6 space-y-6">
                    {shouldShowCloseWonFields(Number(quotation.stageId)) && (
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="flex flex-col space-y-1.5">
                          <label className="text-[9px] font-black text-slate-400 uppercase tracking-widest ml-1">Final Amount</label>
                          <input
                            type="text"
                            name="finalAmount"
                            value={quotation.finalAmount || ""}
                            onChange={handleInputChange}
                            disabled={!isCloseWonEditable(Number(quotation.stageId))}
                            className="w-full rounded-xl border border-slate-200 bg-white px-4 py-2 font-black text-primary text-base"
                          />
                        </div>
                        <div className="flex flex-col space-y-1.5">
                          <label className="text-[9px] font-black text-slate-400 uppercase tracking-widest ml-1">Profile Color</label>
                          <input
                            type="text"
                            name="finalProfileColor"
                            value={quotation.finalProfileColor || ""}
                            onChange={handleInputChange}
                            disabled={!isCloseWonEditable(Number(quotation.stageId))}
                            className="w-full rounded-xl border border-slate-200 bg-white px-4 py-2 font-black text-xs"
                          />
                        </div>
                        <div className="flex flex-col space-y-1.5">
                          <label className="text-[9px] font-black text-slate-400 uppercase tracking-widest ml-1">Glass Color</label>
                          <input
                            type="text"
                            name="glassColorType"
                            value={quotation.glassColorType || ""}
                            onChange={handleInputChange}
                            disabled={!isCloseWonEditable(Number(quotation.stageId))}
                            className="w-full rounded-xl border border-slate-200 bg-white px-4 py-2 font-black text-xs"
                          />
                        </div>
                        <div className="flex flex-col space-y-1.5">
                          <label className="text-[9px] font-black text-slate-400 uppercase tracking-widest ml-1">Win Date</label>
                          <input
                            type="date"
                            name="closeWonDate"
                            value={quotation.workCompleteDate || ""}
                            onChange={handleInputChange}
                            disabled={!isCloseWonEditable(Number(quotation.stageId))}
                            className="w-full rounded-xl border border-slate-200 bg-white px-4 py-2 font-black text-xs"
                          />
                        </div>
                      </div>
                    )}
                    {shouldShowCloseLostReason(Number(quotation.stageId)) && (
                      <div className="flex flex-col space-y-2">
                        <label className="text-[9px] font-black text-slate-400 uppercase tracking-widest ml-1">Rejection Reason</label>
                        <textarea
                          name="reason"
                          value={quotation.reason || ""}
                          onChange={handleInputChange}
                          rows="3"
                          className="w-full rounded-xl border border-red-50 bg-red-50/10 px-4 py-3 outline-none focus:border-red-300 transition-all font-black text-xs"
                          placeholder="Details about why this was unsuccessful..."
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex flex-col md:flex-row items-center justify-end gap-3 pt-6 pb-10">

                {isEditing && (
                  <button
                    type="button"
                    className="w-full md:w-auto px-6 py-2.5 bg-white text-primary text-[10px] font-black uppercase tracking-widest rounded-xl border border-primary/20 hover:bg-primary/5 transition-all active:scale-[0.98] flex items-center justify-center gap-2"
                    onClick={() => handlePrint(quotation.quotation_No)}
                  >
                    <IoPrintSharp className="text-base" />
                    <span>Print</span>
                  </button>
                )}
                {(isEditing ? permission.isUpdate : permission.isInsert) && (
                  <button
                    className="w-full md:w-auto px-8 py-2.5 bg-primary text-white text-[10px] font-black uppercase tracking-widest rounded-xl shadow-md shadow-primary/20 hover:shadow-lg hover:translate-x-1 transition-all active:scale-[0.98] flex items-center justify-center gap-3"
                    type="submit"
                  >
                    <span>{isEditing ? "Update Quotation" : "Initialize Quotation"}</span>
                    <span className="text-base">→</span>
                  </button>
                )}
                <button
                  type="button"
                  className="w-full md:w-auto px-6 py-2.5 bg-white text-slate-600 text-[10px] font-black uppercase tracking-widest rounded-xl border border-slate-200 hover:bg-slate-50 transition-all active:scale-[0.98]"
                  onClick={() => navigate(-1)}
                >
                  Discard Changes
                </button>
              </div>
            </form>
          </div>
        )}
      </div>
      <Model
        isOpen={isItemModalOpen}
        onClose={() => setIsItemModalOpen(false)}
        name="Add New Item"
      >
        <FormFields
          onSubmit={handleSubmit}
          setIsModelOpen={setIsItemModalOpen}
          formData={newItem}
          handleInputChange={handleInputItemChange}
          fields={fields}
          onClear={() => setIsItemModalOpen(false)}
          isEditing={isEditing}
        />
      </Model>
    </>
  );
};

export default ManualDetails;
